import React from "react";

interface ReferralsIconProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
    size?: number;
}

export const ReferralsIcon: React.FC<ReferralsIconProps> = ({
    color = '#253858',
    size = 24,
}) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.8421 15.0469C11.8421 13.4262 9.86295 12.1135 7.42105 12.1135C4.97916 12.1135 3 13.4262 3 15.0469M14.7895 12.8469V10.6469M14.7895 10.6469V8.44688M14.7895 10.6469H12.5789M14.7895 10.6469H17M7.42105 9.91354C6.63936 9.91354 5.88969 9.6045 5.33695 9.05439C4.78421 8.50428 4.47368 7.75818 4.47368 6.98021C4.47368 6.20224 4.78421 5.45614 5.33695 4.90603C5.88969 4.35592 6.63936 4.04688 7.42105 4.04688C8.20274 4.04688 8.95242 4.35592 9.50516 4.90603C10.0579 5.45614 10.3684 6.20224 10.3684 6.98021C10.3684 7.75818 10.0579 8.50428 9.50516 9.05439C8.95242 9.6045 8.20274 9.91354 7.42105 9.91354Z" stroke={color} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}